








































import { Component, Vue, Watch } from "vue-property-decorator";
import WalletSelector from "./WalletSelector.vue";
import { Profile } from "@foxone/api/src/models/hfox";
import { State, Action } from "vuex-class";

@Component({
  components: {
    WalletSelector
  }
})
class SetReceivingWalletAction extends Vue {
  @State(state => state.hfox.profile) profile!: Profile;

  @Action("hfox/loadProfile") loadProfile;

  loading = false;

  wallet = "";

  show = false;

  @Watch("profile")
  handleProfileChange() {
    const platform = this.profile?.platform;
    if (platform === "foxone") {
      this.show = true;
      this.$nextTick(() => {
        this.$common.utils.helper.message(
          this,
          {
            title: this.$t("hfox.wallet.foxone-need-change") as string,
            description: this.$t(
              "hfox.wallet.foxone-need-change.description"
            ) as string,
            ok: this.$t("common.ok") as string,
            cancel: ""
          },
          {
            onOK: () => (this.wallet = "mixin")
          }
        );
      });
    }
  }

  @Watch("show")
  handleChange(value) {
    if (value) {
      this.wallet = this.profile?.platform;
    }
  }

  async handleWalletChange(value) {
    if (value === "foxone") {
      this.$common.utils.helper.message(
        this,
        {
          title: this.$t("hfox.wallet.foxone-not-support") as string,
          description: this.$t(
            "hfox.wallet.foxone-not-support.description"
          ) as string,
          ok: this.$t("common.ok") as string,
          cancel: ""
        },
        {}
      );
      return;
    }
    this.wallet = value;
  }

  async handleConfirm() {
    this.loading = true;
    try {
      await this.$api.hfox.requestBindPlatform({ platform: this.wallet });
      await this.loadProfile();
      this.$common.utils.helper.toast(this, {
        message: this.$t("hfox.set-wallet.success") as string,
        color: "success"
      });
      this.show = false;
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }
}
export default SetReceivingWalletAction;
